import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";

@Component({
    selector: '[audit-panel]',
    templateUrl: './audit-panel.component.html',
})
export class AuditPanelComponent implements AfterViewInit {
    /**
     * suggestionsTplRef!: TemplateRef<any>
     */
    @ViewChild('template', { read: TemplateRef, static: true })
    public templateRef!: TemplateRef<any>;

    /**
     * item: any
     */
    @Input()
    public item: any;

    /**
     * back: EventEmitter<any>
     */
    @Output()
    public back: EventEmitter<any> = new EventEmitter();

    /**
     * constructor
     * @param viewContainer 
     * @param changeDetectorRef 
     */
    constructor(private viewContainer: ViewContainerRef, protected changeDetectorRef: ChangeDetectorRef) { }

    /**
     * A callback method that is invoked immediately after Angular has completed initialization 
     * of a component's view.
     */
    ngAfterViewInit(): void {
        /* Create the view and detect changes */
        this.viewContainer.createEmbeddedView(this.templateRef).detectChanges();
        this.changeDetectorRef.markForCheck();
    }
}